export enum PaymentMethodType {
  Cash = 1,
  Pos = 2,
  Internet = 3,
  Check = 4,
  TabletPos = 5
}
